import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section 
      className="site-hero site-hero--compact relative flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/img/798e2afd07872f4a16ad4f2e1b6e4242.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          {t('hero.title')}
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button variant="primary" size="lg" className="whitespace-nowrap">
            {t('hero.browseFAQ')}
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            className="whitespace-nowrap border-white text-white hover:bg-white hover:text-gray-900"
          >
            {t('hero.contactSupport')}
          </Button>
        </div>
      </div>
    </section>
  );
}
